import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Resizer from "react-image-file-resizer";
import { themes, dateFormat } from "services/constants";
import moment from "moment";
// import { checkEditorPermission } from "services/utils/HelperFunction";
import { ProfilePopup } from "./ProfilePopup";
import { setGlobalSearchValue } from "services/Redux/userToken";
import {
  setEditUserDetailsApi,
  setProfileEditBack,
} from "services/Redux/userManagament";
import * as Mui from "@mui/material";
import BorderColorSharpIcon from "@mui/icons-material/BorderColorSharp";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { userManagementError } from "services/constants/ErrorMessages";
import { showToast } from "services/utils/Status";

export const EditProfile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const domainUrl = useSelector((state) => state.tokenReducer.domain);
  const { token, userDetails } = useSelector((state) => state.tokenReducer);
  const editUserId = useSelector((state) => state.userReducer.editUserId);
  const profileEdit = useSelector((state) => state.userReducer.profileEdit);
  let check_access = true;
  // checkEditorPermission(
  //   userScreenAccess?.module_details,
  //   "Users",
  //   "Users"
  // );
  const backToUserGroup = useSelector(
    (state) => state.userReducer.backToUserGroup
  );
  const editUserDetailsApi = useSelector(
    (state) => state.userReducer.editUserDetailsApi
  );
  const [updateInfo, setUpdateInfo] = useState(false);
  const [editUserData, setEditUserData] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [profile, setProfile] = useState("");
  const [updatedProfile, setupdateProfile] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`${domainUrl}person/${editUserId}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
      });
      if (response.ok) {
        const allUsersJson = await response.json();
        setEditUserData(allUsersJson);
        dispatch(setEditUserDetailsApi(false));
      }
    };
    if (editUserDetailsApi) {
      fetchData();
    }
  }, [dispatch, domainUrl, editUserDetailsApi, editUserId, token]);

  const handleClose = () => {
    setOpenPopup(false);
  };

  useEffect(() => {
    const updateProfileFile = async () => {
      if (profile.size > 1000000) {
        showToast("error", userManagementError.imagesizeError);
      } else {
        const formData = new FormData();
        formData.append("file", profile);
        formData.append("user_id", userDetails?.id);
        try {
          const response = await fetch(`${domainUrl}avatars/`, {
            method: "PUT",
            headers: {
              Authorization: `token ${token}`,
            },
            body: formData,
          });

          if (response.ok) {
            setEditUserData([]);
            dispatch(setEditUserDetailsApi(true));
            window.location.reload();
          } else {
            const errorData = await response.json();
            showToast("error", errorData?.message || "Upload failed");
          }
        } catch (err) {
          showToast("error", "API Response " + err?.message);
        }
      }
    };

    if (updatedProfile) {
      updateProfileFile();
      setupdateProfile(false);
    }
  }, [
    dispatch,
    domainUrl,
    editUserId,
    profile,
    token,
    updatedProfile,
    userDetails?.id,
  ]);

  // useEffect(() => {
  //   const updateProfileFile = async () => {
  //     if (profile.size > 1000000) {
  //       showToast("error", userManagementError.imagesizeError);
  //       dispatch(setEditUserDetailsApi(true));
  //     } else {
  //       const myHeaders = new Headers();
  //       const formData = new FormData();
  //       myHeaders.append("Authorization", `token ${token}`);
  //       formData.append("file", profile, "[PROXY]");
  //       formData.append("user_id", editUserId);
  //       const response = await fetch(`${domainUrl}avatars/`, {
  //         method: "PUT",
  //         headers: myHeaders,
  //         body: formData,
  //         redirect: "follow",
  //       });
  //       if (response.ok) {
  //         setEditUserData([]);
  //         dispatch(setEditUserDetailsApi(true));
  //       }
  //     }
  //   };
  //   if (updatedProfile) {
  //     updateProfileFile();
  //     setupdateProfile(false);
  //   }
  // }, [
  //   dispatch,
  //   domainUrl,
  //   editUserId,
  //   profile,
  //   profileEdit,
  //   token,
  //   updatedProfile,
  // ]);

  // const resizeFile = (file) =>
  //   new Promise((resolve) => {
  //     Resizer.imageFileResizer(
  //       file,
  //       128,
  //       128,
  //       "JPEG",
  //       100,
  //       0,
  //       (uri) => {
  //         resolve(uri);
  //       },
  //       "base64"
  //     );
  //   });

  const navigateToCompanyGroup = () => {
    dispatch(setGlobalSearchValue(""));
    history.push("/admin/view/user/groups");
    dispatch(setProfileEditBack(false));
  };

  return (
    <React.Fragment>
      {profileEdit ? (
        <Mui.Button
          sx={{ marginTop: 2, paddingBottom: 2 }}
          onClick={() => {
            backToUserGroup
              ? navigateToCompanyGroup()
              : history.push("/admin/administration/user");
          }}
        >
          Back
        </Mui.Button>
      ) : (
        <Mui.Grid container sx={{ marginTop: 2, paddingBottom: 2 }}></Mui.Grid>
      )}
      <Mui.Grid container spacing={2} sx={{ padding: 1 }}>
        <Mui.Box sx={{ boxShadow: 3, width: "100%", height: "auto" }}>
          <Mui.Stack
            sx={{
              display: "flex",
              justifyContent: "center",
              border: "2px solid Black",
            }}
          >
            <Mui.Grid container sx={{ height: "auto", display: "flex" }}>
              <Mui.Grid
                xs={3}
                sx={{ paddingTop: 2, paddingLeft: 4, alignContent: "center" }}
              >
                <Mui.Avatar
                  sx={{
                    bgcolor: "#90c6f0",
                    width: 160,
                    height: 160,
                    fontSize: 60,
                  }}
                  alt={editUserData?.full_name?.charAt(0).toUpperCase()}
                  src={editUserData?.image_url}
                />

                <Mui.Stack sx={{ paddingTop: 2 }}>
                  <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => {
                      if (check_access) {
                        // resizeFile(e.target.files[0]);
                        setProfile(e.target.files[0]);
                        setupdateProfile(true);
                        e.target.value = null;
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to change profile`
                        );
                      }
                    }}
                  />
                  <Mui.Button
                    variant="contained"
                    component="label"
                    sx={{ alignItems: "center", width: "200px" }}
                    onClick={() => {
                      if (check_access) {
                        fileInputRef.current.click();
                      } else {
                        showToast(
                          "error",
                          "Access denied: You are not authorized to change profile"
                        );
                      }
                    }}
                  >
                    Change Profile
                    {/* <input
                      style={{ display: "none", width: 300, height: 300 }}
                      accept="image/*"
                      type="file"
                      ref={fileInputRef}
                      onChange={(e) => {
                        if (check_access) {
                          resizeFile(e.target.files[0]);
                          setProfile(e.target.files[0]);
                          setupdateProfile(true);
                        } else {
                          showToast(
                            "error",
                            `Access denied: You are not authorized to change profile`
                          );
                        }
                      }}
                    /> */}
                  </Mui.Button>
                </Mui.Stack>
              </Mui.Grid>
              <Mui.Grid
                xs={3.5}
                sx={{
                  paddingTop: 3,
                  borderRight: "2px solid Black",
                  height: "auto",
                }}
                spacing={2}
              >
                <Mui.Typography
                  sx={{
                    fontSize: 30,
                    color: themes.headLine,
                    paddingBottom: 0.5,
                  }}
                >
                  {editUserData?.full_name}
                </Mui.Typography>
                <Mui.Typography
                  sx={{
                    fontSize: 15,
                    color: themes.headLine,
                    paddingBottom: 0.5,
                  }}
                >
                  {editUserData?.role}
                </Mui.Typography>
                <br />
                <Mui.Stack direction="row">
                  <Mui.Grid xs={5}>
                    <Mui.Typography
                      fontWeight={"bold"}
                      sx={{
                        fontSize: 15,
                        color: themes.headLine,
                        paddingBottom: 0.5,
                      }}
                    >
                      User Code
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}>
                    <Mui.Typography
                      fontWeight={"bold"}
                      sx={{
                        fontSize: 15,
                        color: themes.headLine,
                        paddingBottom: 0.5,
                      }}
                    >
                      :
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.Typography>{editUserData?.user_code}</Mui.Typography>
                  </Mui.Grid>
                </Mui.Stack>
                <Mui.Stack direction="row">
                  <Mui.Grid xs={5}>
                    <Mui.Typography
                      fontWeight={"bold"}
                      sx={{
                        fontSize: 15,
                        color: themes.headLine,
                        paddingBottom: 0.5,
                      }}
                    >
                      Date of Joining
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}>
                    <Mui.Typography
                      fontWeight={"bold"}
                      sx={{
                        fontSize: 15,
                        color: themes.headLine,
                        paddingBottom: 0.5,
                      }}
                    >
                      :
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.Typography>
                      {editUserData?.date_of_join}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Stack>
                <Mui.Stack direction="row">
                  <Mui.Grid xs={5}>
                    <Mui.Typography
                      fontWeight={"bold"}
                      sx={{
                        fontSize: 15,
                        color: themes.headLine,
                        paddingBottom: 0.5,
                      }}
                    >
                      Department Name
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}>
                    <Mui.Typography
                      fontWeight={"bold"}
                      sx={{
                        fontSize: 15,
                        color: themes.headLine,
                        paddingBottom: 0.5,
                      }}
                    >
                      :
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.Typography>
                      {editUserData?.team ? editUserData?.team : "N/A"}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Stack>
                <Mui.Stack direction="row">
                  <Mui.Grid xs={5}>
                    <Mui.Typography
                      fontWeight={"bold"}
                      sx={{
                        fontSize: 15,
                        color: themes.headLine,
                        paddingBottom: 0.5,
                      }}
                    >
                      Department Lead
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.5}>
                    <Mui.Typography
                      fontWeight={"bold"}
                      sx={{
                        fontSize: 15,
                        color: themes.headLine,
                        paddingBottom: 0.5,
                      }}
                    >
                      :
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={8}>
                    <Mui.Typography>
                      {editUserData?.department_lead_name}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Stack>
              </Mui.Grid>
              <Mui.Grid
                xs={5.5}
                sx={{ paddingTop: 2, paddingLeft: 2 }}
                spacing={2}
              >
                <Mui.Grid container>
                  <Mui.Grid xs={4} sx={{ paddingBottom: 1 }}>
                    <Mui.Typography fontWeight={"bold"}>Phone</Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={1} sx={{ fontWeight: "bold" }}>
                    :
                  </Mui.Grid>
                  <Mui.Grid xs={6}>
                    <Mui.Stack direction="Row">
                      <Mui.Grid container justify="flex-start">
                        <Mui.Typography color="blue">
                          {editUserData?.phone_number}
                        </Mui.Typography>
                      </Mui.Grid>
                    </Mui.Stack>
                  </Mui.Grid>
                  <Mui.Grid xs={1}>
                    <Mui.Grid container alignContent="flex-end">
                      <Mui.IconButton
                        sx={{ marginTop: -2.5 }}
                        onClick={() => {
                          if (check_access) {
                            setUpdateInfo(true);
                            setOpenPopup(true);
                          } else {
                            showToast(
                              "error",
                              `Access denied: You are not authorized to edit user profile`
                            );
                          }
                        }}
                      >
                        <BorderColorSharpIcon />
                      </Mui.IconButton>
                    </Mui.Grid>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container>
                  <Mui.Grid xs={4} sx={{ paddingBottom: 1 }}>
                    <Mui.Typography fontWeight={"bold"}>Email</Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={1} sx={{ fontWeight: "bold" }}>
                    :
                  </Mui.Grid>
                  <Mui.Grid xs={7}>
                    <Mui.Typography color="blue">
                      {" "}
                      {editUserData?.email}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container>
                  <Mui.Grid xs={4} sx={{ paddingBottom: 1 }}>
                    <Mui.Typography fontWeight={"bold"}>
                      Birthday
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={1} sx={{ fontWeight: "bold" }}>
                    :
                  </Mui.Grid>
                  <Mui.Grid xs={7}>
                    <Mui.Typography color="blue">
                      {editUserData?.birthday
                        ? moment(editUserData?.birthday).format(dateFormat)
                        : ""}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container>
                  <Mui.Grid xs={4} sx={{ paddingBottom: 1 }}>
                    <Mui.Typography fontWeight={"bold"}>Gender</Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={1} sx={{ fontWeight: "bold" }}>
                    :
                  </Mui.Grid>
                  <Mui.Grid xs={7}>
                    <Mui.Typography color="blue">
                      {editUserData?.gender}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container>
                  <Mui.Grid xs={4} sx={{ paddingBottom: 1 }}>
                    <Mui.Typography fontWeight={"bold"}>
                      Aadhar Number{" "}
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={1} sx={{ fontWeight: "bold" }}>
                    :
                  </Mui.Grid>
                  <Mui.Grid xs={7}>
                    <Mui.Typography color="blue">
                      {editUserData?.aadhar}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container>
                  <Mui.Grid xs={4} sx={{ paddingBottom: 1 }}>
                    <Mui.Typography fontWeight={"bold"}>
                      Pan Number{" "}
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={1} sx={{ fontWeight: "bold" }}>
                    :
                  </Mui.Grid>
                  <Mui.Grid xs={7}>
                    <Mui.Typography color="blue">
                      {" "}
                      {editUserData?.pan}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container>
                  <Mui.Grid xs={4} sx={{ paddingBottom: 1 }}>
                    <Mui.Typography fontWeight={"bold"}>
                      Address{" "}
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={1} sx={{ fontWeight: "bold" }}>
                    :
                  </Mui.Grid>
                  <Mui.Grid xs={7}>
                    <Mui.Typography color="blue">
                      {editUserData?.address}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Stack>
        </Mui.Box>
      </Mui.Grid>
      <ProfilePopup
        handleClose={handleClose}
        open={openPopup}
        title="Profile Information"
        editUserData={editUserData}
        updateInfo={updateInfo}
        setUpdateInfo={setUpdateInfo}
      />
    </React.Fragment>
  );
};
